import { WmButton } from "@watermarkinsights/ripple-react";
import { InstitutionIcon, ProgramIcon } from "@/features/common/Icons";
import { useContext, useReducer } from "react";
import { useIntl } from "react-intl";
import translate from "@/i18n/translate";
import { Program } from "@/features/common/interfaces/Interface";
import { AppContext, AppContextInterface } from "@/contexts/AppContext";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "@/features/common/helper";

interface ContributorProgramInsightsProps {
  programs: Program[];
}

interface State {
  showPrograms: boolean;
}
interface Action {
  type: string;
  showPrograms: boolean;
}

const defaultAction: Action = {
  type: "",
  showPrograms: false
};
const stateReducer = (state: State, action: Action) => {
  switch (action.type) {
    case "togglePrograms":
      return { ...state, showPrograms: !state.showPrograms };
    default:
      return state;
  }
};
const initialState: State = {
  showPrograms: true
};

export function ContributorProgramInsights({
  programs
}: ContributorProgramInsightsProps) {
  const [state, dispatch] = useReducer(stateReducer, initialState);
  const toggleProgram = () => {
    dispatch({ ...defaultAction, type: "togglePrograms" });
  };
  const toggleProgramsLabel = useIntl().formatMessage({
    id: "app.home.togglePrograms"
  });
  return (
    <div className="my-institution-container">
      <div className="flex-row -verticallycentered">
        <button
          className={
            state.showPrograms
              ? "expand-button mdi  mdi-menu-down"
              : "expand-button mdi  mdi-menu-right"
          }
          onClick={toggleProgram}
          aria-label={toggleProgramsLabel}
        ></button>
        <span className="my-institution">
          {translate("app.home.myPrograms")}
        </span>
      </div>
      <div id="program-list-container">
        {state.showPrograms &&
          programs.map((program: Program) => {
            return (
              <ProgramCards
                program={program}
                key={`${program.uuid} ${program.code}`}
              />
            );
          })}
      </div>
    </div>
  );
}

interface ProgramCardsProps {
  program: Program;
}
const ProgramCards = ({ program }: ProgramCardsProps) => {
  const { institution } = useContext<AppContextInterface>(AppContext);
  const navigate = useNavigate();
  const queryString = window.location.search;
  const programUrl = queryString.includes("locale")
    ? `/insights/institution/${institution?.platformUuid}/program/${program.uuid}/${queryString}`
    : `/insights/institution/${institution?.platformUuid}/program/${program.uuid}`;
  function navigateToUrl(url: string) {
    scrollToTop(".home-page-header");
    navigate(url);
  }
  return (
    <div className="institution-name">
      <ProgramIcon />
      <div className="program-button">
        <WmButton
          buttonType="textonly"
          onClick={() => navigateToUrl(programUrl)}
        >
          <div className="instiution-link">{program.name}</div>
        </WmButton>
      </div>
    </div>
  );
};
